import * as t from 'io-ts'

import fetchApi from "ui-io/fetch-api";
import { AssignmentTypeT } from '../../task-io'

const assignmentRoleMapped = {
  Create: 'config_writer',
  Pending: 'publisher',
  Validation: 'validator',
  Publishing: 'publisher',
  Completed: 'config_writer',
}

const WorkflowConfigIO = t.type({
  value: t.type({
    roles: t.array(
      t.type({
        role: t.string,
        users: t.array(t.string),
        teams: t.array(t.string),
        groups: t.array(t.string),
        certificates: t.array(t.string),
      }),
    ),
  }),
})
const FsmGroupIO = t.type({
  name: t.string,
  fsm_group_type: t.string,
  fsm_group_id: t.string,
  fsm_group_revision: t.number,
  fsm_group_partition: t.string,
})

export type FsmGroupT = t.TypeOf<typeof FsmGroupIO>

const FsmPayloadIO = t.partial({
  gws_new_brand: t.type({}),
  fsm_group: t.type({
    fsm_group_type: t.string,
    configuration: t.type({
      workflow_configurations: t.array(WorkflowConfigIO),
    }),
    fsm_group_revision: t.number,
    fsm_group_partition: t.string,
  }),
})
const FsmRelationsIO = t.type({
  fsm_groups: t.array(FsmGroupIO),
})

export const GetFsmIO = t.type({
  fsm: t.intersection([
    t.type({
      fsm_id: t.string,
      fsm_type: t.string,
      fsm_revision: t.number,
      fsm_partition: t.string,
      payload: FsmPayloadIO,
    }),
    t.partial({
      relations: FsmRelationsIO,
    }),
  ]),
})

const OdGroupMembersIO = t.type({
  username: t.string,
  od_groups: t.array(t.string),
})
export const UsersSearchResultIO = t.type({
  
    user_id: t.string,
    name: t.string,
    username: t.string,
    description: t.string,
    // owners: t.array(t.string),
    status: t.string,
    // members: t.array(t.string),
    od_groups: t.array(t.string),
    // od_group_members: t.array(OdGroupMembersIO),
    // uuid: t.string,
    // od_group_locked: t.boolean,
    is_locked: t.boolean,
    is_restricted: t.boolean,

})

export const taskLookupQuery = ({
  taskFSMId,
  fsmRevision,
}: {
  taskFSMId: string
  fsmRevision: number
}) => {
  return {
    queryKey: ['userList', taskFSMId, fsmRevision],
    queryFn: () =>
      fetchApi({
        service: 'user-service',
        method: 'GET',
        pathname: `/tasks/${taskFSMId}/${fsmRevision}`,
        codec: GetFsmIO,
      }),
  }
}

// export const getUserListQuery = ({
//   fsmId,
//   fsmRevision,
//   assignmentType,
// }: {
//   fsmId: string
//   fsmRevision: number
//   assignmentType: AssignmentTypeT
// }) => {
//   return {
//     queryKey: ['userList', fsmId, fsmRevision, assignmentType],
//     queryFn: () =>
//       fetchApi({
//         service: 'plasma-ticket',
//         method: 'GET',
//         pathname: `/get-user${fsmId}/${1}`,
//         codec: GetFsmIO,
//       }).then((fsmData): Promise<Array<string>> => {
//         /* Currently assuming fsm_group to have only one workflow_configurations. This can be changed once we get more clarity on this issue. */
//         const role =
//           fsmData.fsm.payload.fsm_group?.configuration.workflow_configurations[0]?.value.roles?.find(
//             (roleItem) =>
//               roleItem.role === assignmentRoleMapped[assignmentType],
//           )

//         if (!role) {
//           return Promise.resolve([])
//         } else {
//           return Promise.all(
//             role.teams.map((team) =>
//               fetchApi({
//                 service: 'user-service',
//                 method: 'GET',
//                 pathname: `/get-user/teams/${team}`,
//                 codec: UsersSearchResultIO,
//               }).then((userData) => [
//                 ...userData.members,
//                 ...userData.od_group_members.map(
//                   ({ username }) => username,
//                 ),
//               ]),
//             ),
//           ).then((userListArray) =>
//             Array.from(new Set(userListArray.flat())).sort(),
//           )
//         }
//       }),
//   }
// }

export const getAllUsersQuery = ({
  team,
}: {
  team: string
}) => {
  return {
    queryKey: ['allUserList', team],
    queryFn: () =>
      fetchApi({
        service: 'admin-service',
        method: 'GET',
        pathname: `/get-user/teams/${team}`,
        codec: t.array(UsersSearchResultIO),
      }).then((userData) => {
        const userList = userData.map((user:any)=>user.username)
        userList.sort()
        return userList
      }).catch((error) => {
        console.error("Error fetching user list:", error);
        return []
      }),
      
      // .then((userData) => {
      //   // const od_group_members = userData.team.od_group_members.map(
      //   //   (memberDetails) => memberDetails.username,
      //   // )
      //   const userList = [...userData.members]
      //   userList.sort()
      //   return userList
      // }),
  }
}
